import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const AddUser = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M17.9004 8.72633V11.4421M17.9004 11.4421V14.1579M17.9004 11.4421H15.2008M17.9004 11.4421H20.5999M12.9512 7.36843C12.9512 9.1183 11.5412 10.5369 9.80176 10.5369C8.06236 10.5369 6.6523 9.1183 6.6523 7.36843C6.6523 5.61856 8.06236 4.20001 9.80176 4.20001C11.5412 4.20001 12.9512 5.61856 12.9512 7.36843ZM3.48708 17.6548C4.43508 15.0762 6.75025 13.2526 9.80176 13.2526C12.8533 13.2526 15.1684 15.0762 16.1164 17.6548C16.4843 18.6555 15.6343 19.5895 14.5738 19.5895H5.02973C3.96926 19.5895 3.11922 18.6555 3.48708 17.6548Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <>
        <path
          d='M9.80791 3.60001C7.70147 3.60001 5.99387 5.31716 5.99387 7.43537C5.99387 9.55359 7.70147 11.2707 9.80791 11.2707C11.9143 11.2707 13.6219 9.55359 13.6219 7.43537C13.6219 5.31716 11.9143 3.60001 9.80791 3.60001Z'
          fill='currentColor'
        />
        <path
          d='M18.5577 8.78903C18.5577 8.41523 18.2564 8.1122 17.8847 8.1122C17.513 8.1122 17.2116 8.41523 17.2116 8.78903V10.8195H15.1924C14.8207 10.8195 14.5194 11.1225 14.5194 11.4963C14.5194 11.8701 14.8207 12.1732 15.1924 12.1732H17.2116V14.2037C17.2116 14.5775 17.513 14.8805 17.8847 14.8805C18.2564 14.8805 18.5577 14.5775 18.5577 14.2037V12.1732H20.5769C20.9487 12.1732 21.25 11.8701 21.25 11.4963C21.25 11.1225 20.9487 10.8195 20.5769 10.8195H18.5577V8.78903Z'
          fill='currentColor'
        />
        <path
          d='M9.80791 12.6244C6.46797 12.6244 3.91683 14.633 2.87897 17.4549C2.60398 18.2026 2.79091 18.9372 3.22972 19.4631C3.65924 19.9779 4.32627 20.2951 5.04875 20.2951H14.5671C15.2895 20.2951 15.9566 19.9779 16.3861 19.4631C16.8249 18.9372 17.0118 18.2026 16.7368 17.4549C15.699 14.633 13.1478 12.6244 9.80791 12.6244Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
